// Actualizar en Footer.js
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../components/Footer.css';
import { FaFacebook, FaInstagram, FaYoutube, FaDiscord, FaWhatsapp, FaTiktok, FaNewspaper } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import NewsletterModal from './NewsletterModal';

function Footer() {
  const location = useLocation();
  const isAboutPage = location.pathname === '/about';
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <footer className="transparent-footer">
        <div className="social-icons">
          <a href="https://www.facebook.com/profile.php?id=61572805831519" target="_blank" rel="noopener noreferrer">
            <FaFacebook className={`icon`} />
          </a>
          <a href="https://instagram.com/hypothesisgames" target="_blank" rel="noopener noreferrer">
            <FaInstagram className={`icon`} />
          </a>
          <a href="https://twitter.com/hypothesisgame" target="_blank" rel="noopener noreferrer">
            <FaXTwitter className={`icon`} />
          </a>
          <span 
            onClick={() => setIsModalOpen(true)} 
            style={{ cursor: 'pointer' }}
          >
            <FaNewspaper className={`icon ${isAboutPage ? 'highlighted' : ''}`} />
          </span>
          <a href="https://wa.me/56944492472" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp className={`icon ${isAboutPage ? 'highlighted' : ''}`} />
          </a>
          <a href="https://youtube.com/@HypothesisGames" target="_blank" rel="noopener noreferrer">
            <FaYoutube className={`icon`} />
          </a>
          <a href="https://discord.gg/4y7nycv6" target="_blank" rel="noopener noreferrer">
            <FaDiscord className={`icon`} />
          </a>
          <a href="https://www.tiktok.com/@hypothesisgames" target="_blank" rel="noopener noreferrer">
            <FaTiktok className={`icon`} />
          </a>
        </div>
        <p>© {new Date().getFullYear()} Hypothesis Games. All rights reserved.</p>
      </footer>
      
      <NewsletterModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}

export default Footer;